import { Dispatch, ReactNode, SetStateAction, useContext, createContext, useState, useEffect } from 'react';

export const DemoLayout = {
  ROW: 'row',
  GRID: 'grid',
} as const;

export type DemoLayoutType = typeof DemoLayout.ROW | typeof DemoLayout.GRID;

type DemoLayoutContextType = {
  demoLayout: typeof DemoLayout.GRID | typeof DemoLayout.ROW;
  setDemoLayout: Dispatch<SetStateAction<DemoLayoutType>>;
};

const DemoLayoutContext = createContext<DemoLayoutContextType>({} as DemoLayoutContextType);

type DemoLayoutProviderProps = {
  children: ReactNode;
};

const DemoLayoutProvider = ({ children }: DemoLayoutProviderProps) => {
  const [demoLayout, setDemoLayout] = useState<DemoLayoutType>(DemoLayout.ROW);

  useEffect(() => {
    const sessionLayout = sessionStorage.getItem('demo-layout');
    if (sessionLayout === DemoLayout.ROW || sessionLayout === DemoLayout.GRID) {
      setDemoLayout(sessionLayout);
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem('demo-layout', demoLayout);
  }, [demoLayout]);

  const value = { demoLayout, setDemoLayout };
  return <DemoLayoutContext.Provider value={value}>{children}</DemoLayoutContext.Provider>;
};

const useDemoLayout = () => {
  const context = useContext(DemoLayoutContext);
  if (context === undefined) {
    throw new Error('useDemoLayout must be used from within a DemoLayoutProvider');
  }
  return context;
};

export { DemoLayoutProvider, useDemoLayout };
